import store from '../store';

export const guard = (from, to, next) => {
  if (!store.getters.loggedIn) {
    store.dispatch('doVerifyUser', next);
  } else {
    next();
  }
};
